/**
 * 藝人功能 Remote Config 開關與藝人頁分頁（U1／U2）. Pure — no React / Firebase — so node:test can import it.
 *   artist_fans_enabled：付費鐵粉主開關（月卡、鐵粉名單、收款、限動回覆）；預設 false。
 *   artist_dm_enabled：私訊；實際生效還需要鐵粉主開關（AGENTS.md）。
 */

export const ARTIST_FANS_FLAG = "artist_fans_enabled";
export const ARTIST_DM_FLAG = "artist_dm_enabled";

export interface ArtistFlags {
  /** RC artist_fans_enabled */
  fansEnabled: boolean;
  /** RC artist_dm_enabled (raw) */
  dmFlag: boolean;
  /** DM is effective only when both the fans master and the DM flag are on. */
  dmEnabled: boolean;
}

/** Only an explicit boolean true or the string "true" turns a flag on; missing / failed / anything else is off. */
export const parseRcFlag = (value: unknown): boolean =>
  value === true || (typeof value === "string" && value.trim().toLowerCase() === "true");

export const toArtistFlags = (fans: unknown, dm: unknown): ArtistFlags => {
  const fansEnabled = parseRcFlag(fans);
  const dmFlag = parseRcFlag(dm);
  return { fansEnabled, dmFlag, dmEnabled: fansEnabled && dmFlag };
};

export const ARTIST_FLAGS_OFF: ArtistFlags = { fansEnabled: false, dmFlag: false, dmEnabled: false };

/** Which flag a nav entry / tab depends on. */
export type ArtistFlagGate = "fans" | "dm";
export const flagAllows = (gate: ArtistFlagGate | undefined, flags: ArtistFlags): boolean =>
  gate === undefined || (gate === "fans" ? flags.fansEnabled : flags.dmEnabled);

/** `?tab=` keys of /actors/:id/edit (other pages link to e.g. ?tab=content). */
export const ARTIST_TAB_KEYS = ["overview", "profile", "members", "content", "fans", "actor"] as const;
export type ArtistTabKey = (typeof ARTIST_TAB_KEYS)[number];
export const ARTIST_TAB_LABELS: Record<ArtistTabKey, string> = {
  overview: "總覽",
  profile: "專頁資料",
  members: "成員與開通",
  content: "內容",
  fans: "鐵粉與私訊",
  actor: "短劇演員資料",
};
export const DEFAULT_ARTIST_TAB: ArtistTabKey = "overview";

export const parseArtistTab = (raw: string | null | undefined): ArtistTabKey =>
  (ARTIST_TAB_KEYS as readonly string[]).includes(raw ?? "") ? (raw as ArtistTabKey) : DEFAULT_ARTIST_TAB;
